/**
 * @file: useConfirm.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import type { ConfirmScreenProps } from '@euler/app/flows/common/ConfirmScreen';
import {
  kDefaultCancelButtonText,
  kDefaultConfirmButtonText,
} from '@euler/functions/constants';
import { useNavigationRef } from '@euler/functions/navigation/NavigationContainerRefContext';
import { StackActions } from '@react-navigation/native';
import { useCallback } from 'react';
import { Alert, Platform } from 'react-native';

export const useConfirm = () => {
  const navigationRef = useNavigationRef();
  return useCallback(
    async (props: Omit<ConfirmScreenProps, 'onConfirm' | 'onCancel'>) => {
      return await new Promise<boolean>(resolve => {
        if (Platform.OS === 'web') {
          navigationRef.dispatch(
            StackActions.push('_confirm', {
              ...props,
              onConfirm: () => {
                resolve(true);
              },
              onCancel: () => {
                resolve(false);
              },
            }),
          );
        } else {
          Alert.alert(props.title, props.message, [
            {
              text: props.confirmButtonText ?? kDefaultConfirmButtonText,
              style: props.destructive ? 'destructive' : 'default',
              onPress: () => resolve(true),
            },
            {
              text: props.cancelButtonText ?? kDefaultCancelButtonText,
              style: 'cancel',
              onPress: () => resolve(false),
            },
          ]);
        }
      });
    },
    [navigationRef],
  );
};
